<template>
  <div>
    <CCol sm="12">
        <CCard>
            <CCardBody class="d-flex flex-column">
                <CCol sm="12">
                    <!-- Date -->
                    <CRow>
                        <CCol sm="12">
                            <label class="">Data*</label>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="12">
                            <CInput class="w-100" type="date" @change="dateChanged" :is-valid="dateValidator"/> 
                        </CCol>
                    </CRow>
                    <!-- Tasks -->
                    <CRow class="mt-3">
                        <CCol sm="12">
                            <label class="">Tarefas*</label>
                        </CCol>
                    </CRow>
                    <CCol>
                        <CRow>
                            <div v-for="task in tasks" :key="task.id" class="form-check col-6 col-md-3">
                                <input class="form-check-input" type="checkbox" :value="task" :id="'task-'+task.id" v-model="operation.tasks" @click="taskClicked(task)" v-bind:class="{'is-invalid': areTasksValid == false}">
                                <label class="form-check-label" :for="'task-'+ task.id">
                                    {{ task.name }}
                                </label>
                                <span class="ml-3" v-if="task.tools.filter(function(tool){ return tool.selected }).length"><u>{{task.tools.filter(function(tool){ return tool.selected }).map(tool => tool.name).join(", ")}}</u></span>
                            </div>
                        </CRow>
                    </CCol>
                    <!-- Places -->
                    <CRow class="mt-3">
                        <CCol sm="12">
                            <label class="">Locais*</label>
                        </CCol>
                    </CRow>
                    <CCol>
                        <CRow>
                            <div v-for="place in places" :key="place.id" class="form-check col-6 col-md-3">
                                <input class="form-check-input" type="checkbox" :value="place" :id="'place-'+place.id" v-model="operation.places" v-bind:class="{'is-invalid': arePlacesValid == false}">
                                <label class="form-check-label" :for="'place-'+ place.id">
                                    {{ place.name }}
                                </label>
                            </div>
                        </CRow>
                    </CCol>
                    <!-- Human resources -->
                    <CRow class="mt-3">
                        <CCol sm="12">
                            <label class="">Recursos humanos*</label>
                        </CCol>
                    </CRow>
                    <CCol>
                        <CRow>
                            <div v-for="person in people" :key="person.id" class="form-check col-6 col-md-3">
                                <input class="form-check-input" type="checkbox" :value="person" :id="'person-'+person.id" v-model="operation.people" @click="personClicked(person)" v-bind:class="{'is-invalid': arePeopleValid == false}">
                                <label class="form-check-label" :for="'person-'+ person.id">
                                    {{ person.name }}
                                </label>
                                <span class="ml-3" v-if="person.hours"><u>{{person.hours}} {{person.hours == 1 ? "hora" : "horas"}}</u></span>
                            </div>
                        </CRow>
                    </CCol>
                    <!-- Notes -->
                    <CRow class="mt-3">
                        <CCol sm="12">
                            <label class="">Notas</label>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="12">
                            <CTextarea vertical rows="3" v-model="operation.notes"/>
                        </CCol>
                    </CRow>
                    <!-- Action button -->
                    <CCol class="d-flex justify-content-end mt-3">
                        <CRow sm="2" class="align-self-end">
                            <CSpinner v-if="loading" variant="success" small></CSpinner>
                            <CButton v-else type="button" class="btn btn-primary" @click="submitClicked">Submeter</CButton>
                        </CRow>
                    </CCol>
                </CCol>
            </CCardBody>
        </CCard>
    </CCol>
    <WorkingHoursModal v-if="showWorkingHoursModal" v-model="showWorkingHoursModal" :personName="selectedPerson.name" @ok-tapped="hoursOkTapped" @cancel-tapped="hoursCancelTapped"></WorkingHoursModal>
    <ToolsAttributesModal v-if="showToolsAttributesModal" v-model="showToolsAttributesModal" :task="selectedTask" @ok-tapped="toolsOkTapped" @cancel-tapped="toolsCancelTapped"></ToolsAttributesModal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Operation from "@/classes/Operation";
import InputOperation from "@/classes/InputOperation";
import { UTILS_HELPER } from "@/helpers/utils.js";
import router from '@/router';
import WorkingHoursModal from '../controls/WorkingHoursModal.vue'
import ToolsAttributesModal from '../controls/ToolsAttributesModal.vue'

export default {
    components: { WorkingHoursModal, ToolsAttributesModal },
    props:{    
        baseOperation:
        {
            type: Object,
            default: null
        }
    },
    data()
    {
        return {
            submitted: false,
            operation: new Operation(),
            loading: false,
            /* Pop ups */
            showWorkingHoursModal: false,
            selectedPerson: null,
            showToolsAttributesModal: false,
            selectedTask: null
        }
    },
    computed:
    {
        ...mapState('alert', ['type']),
        ...mapState('alert', ['message']),
        ...mapState({
            tasksListOutput: state => state.tasks.listOutput,
            placesListOutput: state => state.places.listOutput,
            peopleListOutput: state => state.people.listOutput
        }),
        tasks: function() {
            var result = [];
            if(this.tasksListOutput && this.tasksListOutput.obj)
            {
                result = this.tasksListOutput.obj.tasks;
            }

            return result;
        },
        places: function() {
            var result = [];
            if(this.tasksListOutput && this.placesListOutput.obj)
            {
                result = this.placesListOutput.obj.places;
            }

            return result;
        },
        people: function() {
            var result = [];
            if(this.tasksListOutput && this.peopleListOutput.obj)
            {
                result = this.peopleListOutput.obj.users;
            }

            return result;
        },
        areTasksValid()
        {
            return this.arrayValidator(this.operation.tasks);
        },
        arePlacesValid()
        {
            return this.arrayValidator(this.operation.places);
        },
        arePeopleValid()
        {
            return this.arrayValidator(this.operation.people);
        },
    },
    methods:{
        resetOperation(){
            if(!this.baseOperation)
            {
                this.operation = new Operation(null, [], [], []);
            }
            else
            {
                this.operation = UTILS_HELPER.deepClone(new Operation, this.baseOperation);
            }
        },
        dateChanged(val){
            this.operation.date = UTILS_HELPER.formatDate(val);
        },
        submitClicked(){
            this.submitted = true;
            // Emit event
            if(this.operation.isValid())
            {
                var input = new InputOperation(null, this.operation);
                // TODO Replace by Operation id
                if(this.baseOperation && this.$route.params.id)
                {
                    input.id = this.$route.params.id;
                }

                this.loading = true;
                this.$emit('submit-requested', input);
            }
        },
        personClicked(person)
        {
            if(this.operation.people.includes(person))
            {
                this.operation.people.find(operationPerson => operationPerson.id == person.id).hours = null;
                this.selectedPerson = null;
            }
            else
            {
                this.selectedPerson = person;
            }
        },
        hoursOkTapped(hours)
        {
            this.selectedPerson.hours = hours;
            this.selectedPerson = null;
        },
        hoursCancelTapped()
        {
            let self = this;

            if(this.operation.people.includes(this.selectedPerson))
            {
                this.operation.people = this.operation.people.filter(function(person){ return person.id != self.selectedPerson.id; });
            }

            this.selectedPerson = null;
        },
        taskClicked(task)
        {
            if(this.operation.tasks.includes(task))
            {
                this.operation.tasks.find(operationTask => operationTask.id == task.id).tools.forEach(tool => {
                    tool.selected = false
                });
                this.selectedTask = null;
            }
            else if(task.tools.length)
            {
                this.selectedTask = task;
            }
        },
        toolsOkTapped(tools)
        {
            this.selectedTask.tools = tools;
            this.selectedTask = null;
        },
        toolsCancelTapped()
        {
            let self = this;
            if(this.operation.tasks.includes(this.selectedTask))
            {
                this.operation.tasks = this.operation.tasks.filter(function(task){ return task.id != self.selectedTask.id; });
            }

            this.selectedTask = null;
        },
        genericValidator(){
            var result = undefined; // This is the default, in case the user hasn't submitted yet

            // Validate error
            if(this.submitted && this.addError)
            {
                result = false;
            }

            return result;
        },
        dateValidator(){
            var result = this.genericValidator();

            if(this.submitted && result != false)
            {
                result = Boolean(this.operation.date);
            }

            return result;
        },
        arrayValidator(val)
        {
            var result = this.genericValidator();
            if(this.submitted && result != false)
            {
                result = Boolean(val && Array.isArray(val) && val.length); 
            }

            return result;
        }
    },
    mounted: function()
    {
        if(!this.tasks.length || !this.places.length || !this.people.length)
        {
            router.push({ path: '/operacoes/lista' });
        }

        this.resetOperation();
    },
    watch:
    {
        baseOperation: function(val)
        {
            this.resetOperation();
        },
        type: function()
        {
            this.addError = this.type == "alert-danger" ? this.message : '';
            this.loading = false;
        },
        message: function()
        {
            this.addError = this.type == "alert-danger" ? this.message : '';
            this.loading = false;
        },
        selectedPerson: function(val, oldVal)
        {
            this.showWorkingHoursModal = Boolean(val);
        },
        selectedTask: function(val, oldVal)
        {
            this.showToolsAttributesModal = Boolean(val);
        },
    }
}
</script>

<style scoped>
/* Here is a way to trigger the datepicker when users click on the field itself */
/deep/input[type="date"] {
    position: relative;
}

/* create a new arrow, because we are going to mess up the native one
see "List of symbols" below if you want another, you could also try to add a font-awesome icon.. */
/deep/input[type="date"]:after {
    content: "\25BC"; 
    color: #555;
    padding: 0 5px;
}

/* change color of symbol on hover */
/deep/input[type="date"]:hover:after {
    color: #bf1400;
}

/* make the native arrow invisible and stretch it over the whole field so you can click anywhere in the input field to trigger the native datepicker*/
/deep/input[type="date"]::-webkit-calendar-picker-indicator {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: auto;
    height: auto;
    color: transparent;
    background: transparent;
}

/* adjust increase/decrease button */
/deep/input[type="date"]::-webkit-inner-spin-button {
    z-index: 1;
}

 /* adjust clear button */
/deep/input[type="date"]::-webkit-clear-button {
     z-index: 1;
 }

/* Invalid checkbox options */
.form-check-input.is-invalid
{
    outline: 1px solid #e55353;
}

.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label
{
    color: black;
}
</style>